import { Price } from "../model/Items";

export const formatCurrency = (value: number | null) => value?.toFixed(2);

export const roundCurrency = (value: number | null) => Number(formatCurrency(value));

export const getDisplayedPrice = (price?: Price) => {
  if (price === undefined) {
    return '<brak ceny w wybranym cenniku>';
  } else {
    const priceAdjustment = price.adjustment;
    return `${formatCurrency(price.effective)} ${priceAdjustment ? `(${formatCurrency(price.base)} + ${priceAdjustment}%)` : ''}`;
  }
};

export const incrementByPercent = (value: number, percent: number) => Number((value + (value * percent / 100)).toFixed(2));